var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98467 17.799C10.9364 17.799 12.7349 17.1739 14.208 16.1325L19.7454 21.6178C20.0034 21.8726 20.3399 22 20.7026 22C21.4616 22 22 21.4212 22 20.6805C22 20.3335 21.8841 19.9976 21.6261 19.7547L16.1224 14.2924C17.2815 12.7878 17.9694 10.9246 17.9694 8.89933C17.9694 4.00435 13.9276 0 8.98467 0C4.05299 0 0 3.9925 0 8.89933C0 13.7947 4.04178 17.799 8.98467 17.799ZM8.98467 15.8778C5.12981 15.8778 1.9405 12.7185 1.9405 8.89933C1.9405 5.08052 5.12981 1.92125 8.98467 1.92125C12.8395 1.92125 16.0289 5.08052 16.0289 8.89933C16.0289 12.7185 12.8395 15.8778 8.98467 15.8778Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.dab02bd5dec866967a2b46bf0d03ba71.svg";
export { ForwardRef as ReactComponent };